import useIsLearnViewAvailable from "hooks/useIsLearnViewAvailable";

import { AssistantPanelView } from "../Layout/types";
import useIsAssistantPageMode from "./useIsAssistantPageMode";

const useAssistantPanelAvailableViews = () => {
  const isLearnViewAvailable = useIsLearnViewAvailable();
  const isAssistantPageMode = useIsAssistantPageMode();

  const views: AssistantPanelView[] = [];

  if (isLearnViewAvailable && !isAssistantPageMode) {
    views.push(AssistantPanelView.LEARN);
  }

  views.push(AssistantPanelView.CHAT);

  return views;
};

export default useAssistantPanelAvailableViews;
